import { computed, inject, Signal } from '@angular/core';
import { UserDetailDto } from '@artemis-software/wr-api';
import { CurrentUserService } from '@services/current-user.service';
import TenantTypeEnum = UserDetailDto.TenantTypeEnum;

export function canViewRepairTasks(user: UserDetailDto | undefined | null): boolean {
  if (!user) {
    return false;
  }
  if (user.tenantType !== TenantTypeEnum.External) {
    return true;
  }
  return user.tenant.permissions.canEditRepairTasks;
}

export function repairTasksVisible(): Signal<boolean> {
  const currentUserService = inject(CurrentUserService);
  return computed(() => canViewRepairTasks(currentUserService.currentUser()));
}
